export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'An indicator type with the same name already exists'
    }
  }
}
